import React from 'react';
import { useCompetition } from './CompetitionContext';
import { useAuth } from './auth/AuthContext';

// Shows the regatta name and year at the top of public pages (timetable/draw)
// for visitors without any assigned role. Role holders already have meeting
// context via the admin chrome, so the banner stays out of their way.
export function PublicRegattaHeader() {
    const { competitionName } = useCompetition();
    const { roles } = useAuth();

    const hasAnyRole = Array.isArray(roles) && roles.length > 0;
    const title = String(competitionName || '').trim();
    if (hasAnyRole || !title) return null;

    return (
        <div className="public-regatta-header">
            <h2 className="public-regatta-header-title">{title}</h2>
        </div>
    );
}
